import { render } from "./RatingButton.vue?vue&type=template&id=3a328d52&scoped=true"
import script from "./RatingButton.vue?vue&type=script&lang=js"
export * from "./RatingButton.vue?vue&type=script&lang=js"

import "./RatingButton.vue?vue&type=style&index=0&id=3a328d52&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a328d52"]])

export default __exports__